import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DepartureIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DepartureGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.4642 20.113H3.38234C3.1023 20.113 2.87571 19.8864 2.87571 19.6063C2.87571 19.3263 3.1023 19.0997 3.38234 19.0997H21.4642C21.7442 19.0997 21.9708 19.3263 21.9708 19.6063C21.9708 19.8864 21.7442 20.113 21.4642 20.113Z"
        fill="#696969"
      />
      <path
        d="M8.65594 16.2391C8.18444 16.2391 7.71342 16.1303 7.27705 15.9131L3.51344 14.0365L3.50998 14.035C3.04886 13.8005 2.70649 13.4007 2.5462 12.9089C2.3859 12.4176 2.42696 11.8927 2.66098 11.4316C3.08399 10.5984 4.04086 10.1888 4.93587 10.4515L8.39767 11.4726L19.1017 6.48105C20.5103 5.86458 21.7333 6.59435 22.2182 7.63135C22.701 8.66589 22.4749 10.07 21.1069 10.7508L9.96257 15.9477C9.54549 16.1421 9.10072 16.2391 8.65594 16.2391ZM3.96764 13.1311L7.72926 15.0062C8.29922 15.2902 8.95724 15.2981 9.53413 15.0295L20.6671 9.83798C21.4835 9.43128 21.576 8.65056 21.2999 8.05983C21.0233 7.46811 20.3663 7.03569 19.5188 7.40428L8.65247 12.4721C8.54016 12.5245 8.41301 12.5344 8.29476 12.4988L4.64842 11.4232C4.22391 11.2975 3.76626 11.4924 3.56441 11.8902C3.4526 12.1104 3.4333 12.3608 3.50949 12.5953C3.58569 12.8288 3.74846 13.0193 3.96764 13.1311Z"
        fill="#696969"
      />
      <path
        d="M11.9589 10.8898C11.8362 10.8898 11.715 10.8453 11.62 10.7597L6.06541 5.76069C5.93925 5.6469 5.8779 5.47769 5.90313 5.30948C5.92836 5.14127 6.03622 4.9968 6.19008 4.92506L7.96675 4.09634C8.66237 3.77277 9.46289 3.82521 10.1085 4.23784L16.1817 8.11475C16.3375 8.21419 16.4266 8.39082 16.4147 8.57487C16.4023 8.75941 16.2905 8.92268 16.1233 9.00085L12.1732 10.8423C12.1044 10.8745 12.0317 10.8898 11.9589 10.8898ZM7.31218 5.51975L12.0485 9.78256L14.8587 8.47245L9.56333 5.09178C9.21008 4.86617 8.7732 4.83698 8.39522 5.0146L7.31218 5.51975Z"
        fill="#696969"
      />
    </svg>
  );
};

export default DepartureIcon;
